// PlaylistMenu.js
import React, { useState } from 'react'
import ReleaseSongOptions from '../ReleaseSongOptions'
import PlayQueueActions from 'reducers/PlayQueue'
import ModalActions from 'reducers/Modal'
import PlaylistActions, { thunks as PlaylistThunks } from 'reducers/PlayList'
import NotificationActions from 'reducers/Notification'
import { NotificationType } from 'constants/enums'
import { RoundShadowButton } from 'components'
import { plusLogo } from 'images'

const PlaylistMenu = ({
  song,
  dispatch,
  hovered,
  playlists,
  popoverOptions
}) => {
  const [showPlaylistModal, setShowPlaylistModal] = useState(false)

  const handleAddToggle = () => {
    setShowPlaylistModal((prevState) => !prevState)
  }
  const hideTrigger = !hovered && !showPlaylistModal

  const handlePlayNext = () => {
    dispatch(PlayQueueActions.insertItemNext(song))
  }

  const handlePlayAtTheBottom = () => {
    dispatch(PlayQueueActions.insertItemAtBottom(song))
  }

  const handleCreatePlaylist = (track) => {
    dispatch(PlaylistActions.setSongsToAdd([track.trackid]))
    dispatch(ModalActions.openPlaylistModal('release_details'))
  }

  const handleAddToPlaylist = (playlist, track) => {
    dispatch(
      PlaylistThunks.addTracks(playlist.playlistid, [track.trackid], () =>
        dispatch(
          NotificationActions.broadcastMessage(
            {
              songTitle: track.artist + ' - ' + track.title,
              playlistTitle: playlist.name
            },
            NotificationType.addedToPlaylist
          )
        )
      )
    )
  }

  const renderToggleBtn = ({ ref, onClick }) => (
    <RoundShadowButton
      removeTextComponent
      innerRef={ref}
      icon={plusLogo}
      cicleWidthClass="w-6"
      imageWidthClass="w-3"
      onClick={onClick}
    />
  )

  return (
    <ReleaseSongOptions
      isOpen={showPlaylistModal}
      hideTrigger={hideTrigger}
      song={song}
      playlists={playlists}
      popoverOptions={popoverOptions}
      onToggle={handleAddToggle}
      onPlayNextClick={handlePlayNext}
      onPlayLaterClick={handlePlayAtTheBottom}
      onCreatePlaylist={handleCreatePlaylist}
      onAddTrackToPlaylist={handleAddToPlaylist}
      renderToggleBtn={renderToggleBtn}
    />
  )
}

export default PlaylistMenu
